import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TAnyClientQuestionType } from '@hubertai/screening-question-types';
import RuleActionJumpToTarget from '../RuleActionJumpToTarget';
import type { TRuleEditorCommonProps } from '../types';

interface Props extends TRuleEditorCommonProps {
  targetIds: string[];
  renderLanguages: (questionConfig: TAnyClientQuestionType) => ReactNode;
  onMoveUp: (idx: number) => void;
  onMoveDown: (idx: number) => void;
  onRemove: (idx: number) => void;
}

const RuleActionJumpToList = ({ targetIds, renderLanguages, isReadOnly, onMoveUp, onMoveDown, onRemove }: Props) => {
  const { t } = useTranslation('Templates');

  if (!targetIds.length) {
    return <div className="m-2 text-center text-red-600">{t('question.ruleActions.noQuestionsAdded')}</div>;
  }

  return (
    <ol>
      {targetIds.map((targetId, idx) => (
        <RuleActionJumpToTarget
          key={`${targetId}-${idx}`}
          targetId={targetId}
          renderLanguages={renderLanguages}
          isReadOnly={isReadOnly}
          onMoveUp={idx > 0 ? () => onMoveUp(idx) : undefined}
          onMoveDown={idx < targetIds.length - 1 ? () => onMoveDown(idx) : undefined}
          onRemove={() => onRemove(idx)}
        />
      ))}
    </ol>
  );
};

export default RuleActionJumpToList;
